module.exports = __webpack_public_path__ + "static/img/flags.9c74e17.png";


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-css/themes/default/assets/images/flags.png
// module id = 226
// module chunks = 2